import { useDirection } from '@eti/providers';
import { Inline } from '@etg/wings';
import { Link } from 'react-router-dom';
import { CaretLeft } from '@phosphor-icons/react';

interface BackToPreviousPageButtonProps {
  dataTestId: string;
  linkText: string;
  route: string;
}

const BackToPreviousPageButton = ({
  dataTestId,
  linkText,
  route,
}: BackToPreviousPageButtonProps) => {
  const { isRTL } = useDirection();

  return (
    <Link data-testid={dataTestId} to={route}>
      <Inline alignY="center" spacing={4}>
        <CaretLeft mirrored={isRTL} size={20} weight="light" />
        {linkText}
      </Inline>
    </Link>
  );
};

export default BackToPreviousPageButton;
